
import { defineComponent, inject, ref } from 'vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { MEDIA_TYPES } from '@/types/enums';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  emits: [
    'open-file-list',
    'upload-file',
  ],
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;
    const isOpen = ref(false);
    const fileInput = ref();

    function hidePopUp() {
      isOpen.value = false;
    }

    function openFileList() {
      emit('open-file-list');
      hidePopUp();
    }

    function uploadFile(event: Event) {
      const fileList: FileList | null = (event.target as HTMLInputElement).files;
      if (fileList) {
        emit('upload-file', fileList[0]);
        hidePopUp();
      }
      fileInput.value!.value = '';
    }

    return {
      isOpen,
      fileInput,
      MEDIA_TYPES,
      hidePopUp,
      openFileList,
      uploadFile,
    };
  },
});
